<template>
    <span
        v-if="status.message"
        class="font--12"
        :class="`text-${status.code}`"
    >
        {{ message }}
    </span>
</template>

<script>
export default {
    props: {
        status: {
            type: Object,
            default: () => ({}),
            validator: status => {
                const { code } = status
                const validCode =
                    code &&
                    ["danger", "info", "success", "warning"].includes(code)
                return !code || validCode
            },
        },
    },

    computed: {
        message() {
            const message = this.status.message
            if (typeof message == "string") return message
            //For arrays
            if (message.length) {
                return message.join(". ")
            }
            return message.toString()
        },
    },
}
</script>
